import { Header } from 'antd/es/layout/layout';
import { LanguageContext } from 'context/languageContext';
import { useContext } from 'react';

import BoxHeader from './BoxHeader';
import styles from './index.module.css';
import SearchBox from './SearchBox';

const MainHeader = () => {
  const { t } = useContext(LanguageContext);

  return (
    <Header className={styles.header}>
      <div className={styles.headerWrapper}>
        <h2 className={styles.textHeader}>{t('mainHeader')}</h2>
        <SearchBox />
        <BoxHeader />
      </div>
    </Header>
  );
};

export default MainHeader;
